var render, staticRenderFns
import script from "./EntrySiderItem.vue?vue&type=script&lang=js&"
export * from "./EntrySiderItem.vue?vue&type=script&lang=js&"
import style0 from "./EntrySiderItem.vue?vue&type=style&index=0&id=1452f65f&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1452f65f')) {
      api.createRecord('1452f65f', component.options)
    } else {
      api.reload('1452f65f', component.options)
    }
    
  }
}
component.options.__file = "src/components/EntryLayout/EntrySiderItem.vue"
export default component.exports